module.exports = __webpack_public_path__ + "static/img/p15_34.8949bdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/filmSelfPrinter/p15_34.jpg
// module id = wBDP
// module chunks = 0